
    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    module.exports = {
  "contentWidthDefault": "1280px",
  "contentWidthText": "768px",
  "contentWidthFull": "100%",
  "spacing2Xs": "0.25rem",
  "spacingXs": "0.5rem",
  "spacingS": "0.75rem",
  "spacingM": "1rem",
  "spacingL": "1.5rem",
  "spacingXl": "2rem",
  "spacing2Xl": "3rem",
  "spacing3Xl": "4rem",
  "spacing4Xl": "5rem",
  "zIndexNegative": -1,
  "zIndexWorkbench": 0,
  "zIndexDefault": 1,
  "zIndexWorkbenchHeader": 10,
  "zIndexModal": 100,
  "zIndexModalContent": 101,
  "zIndexDropdown": 1000,
  "zIndexTooltip": 10000,
  "zIndexNotification": 100000,
  "borderRadiusSmall": "2px",
  "borderRadiusMedium": "4px",
  "boxShadowDefault": "0 1px 3px rgba(0, 0, 0, 0.08)",
  "boxShadowHeavy": "0 2px 3px rgba(0, 0, 0, 0.35)",
  "glowPrimary": "0px 0px 7px #2E75D4",
  "glowNegative": "0px 0px 7px #BF3045",
  "glowPositive": "0px 0px 7px #16875D",
  "glowWarning": "0px 0px 7px #F79B0C",
  "colorBlueDark": "#174E8C",
  "colorBlueBase": "#2D64B3",
  "colorBlueMid": "#2E75D4",
  "colorBlueLight": "#84B9F5",
  "colorBlueLightest": "#EDF4FC",
  "colorContrastDark": "#0C141C",
  "colorContrastMid": "#192532",
  "colorContrastLight": "#263545",
  "colorCoralDark": "#d0a2a0",
  "colorCoralMid": "#fbe3e2",
  "colorElementDarkest": "#b4c3ca",
  "colorElementDark": "#c3cfd5",
  "colorElementMid": "#d3dce0",
  "colorElementLight": "#e5ebed",
  "colorElementLightest": "#f7f9fa",
  "colorGreenDark": "#1A593E",
  "colorGreenBase": "#1A6848",
  "colorGreenMid": "#16875D",
  "colorGreenLight": "#8AD6B1",
  "colorGreenLightest": "#D9F2E4",
  "colorIceDark": "#c5d2d8",
  "colorIceMid": "#e8f7ff",
  "colorMintDark": "#b7ded0",
  "colorMintMid": "#f4fffb",
  "colorOrangeDark": "#A85701",
  "colorOrangeBase": "#DE8907",
  "colorOrangeMid": "#F79B0C",
  "colorOrangeLight": "#FFD7A2",
  "colorOrangeLightest": "#FFE8C7",
  "colorPeachDark": "#d2ac79",
  "colorPeachMid": "#ffe9cc",
  "colorPurpleDark": "#6426A2",
  "colorPurpleBase": "#7439B0",
  "colorPurpleMid": "#8B4DC9",
  "colorPurpleLight": "#D3ADF6",
  "colorPurpleLightest": "#F1E2FF",
  "colorRedDark": "#7C262F",
  "colorRedBase": "#A82D3E",
  "colorRedMid": "#BF3045",
  "colorRedLight": "#ECA7A7",
  "colorRedLightest": "#FCE9E8",
  "colorPrimary": "#2E75D4",
  "colorPositive": "#16875D",
  "colorNegative": "#BF3045",
  "colorWarning": "#F79B0C",
  "colorTextDark": "#192532",
  "colorTextBase": "#283848",
  "colorTextMid": "#536171",
  "colorTextLight": "#606C7C",
  "colorTextLightest": "#6B7888",
  "colorWhite": "#ffffff",
  "colorYellowDark": "#CBA125",
  "colorYellowBase": "#E0B73A",
  "colorYellowMid": "#FFD354",
  "colorYellowLight": "#FFE69B",
  "colorYellowLightest": "#FFF7DE",
  "transitionDurationShort": "0.1s",
  "transitionDurationDefault": "0.2s",
  "transitionDurationLong": "0.3s",
  "transitionEasingDefault": "ease-in-out",
  "transitionEasingCubicBezier": "cubic-bezier(0.13, 0.62, 0.11, 0.99)",
  "fontBaseDefault": "16",
  "fontSize3Xl": "2.1875rem",
  "fontSize2Xl": "1.75rem",
  "fontSizeXl": "1.3125rem",
  "fontSizeL": "1rem",
  "fontSizeM": "0.875rem",
  "fontSizeS": "0.75rem",
  "fontStackPrimary": "-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
  "fontStackMonospace": "SFMono-Regular, Consolas, Liberation Mono, Menlo,monospace",
  "fontWeightNormal": 400,
  "fontWeightMedium": 600,
  "fontWeightDemiBold": 700,
  "letterSpacingWide": "0.1rem",
  "lineHeightDefault": "1.5",
  "lineHeightCondensed": "1.25"
}
    